const convertTimeStampToDate = (
  timeStamp: number,
  options?: Intl.DateTimeFormatOptions,
  hasTime: boolean = true,
) => {
  if (!timeStamp) return '-';
  return Intl.DateTimeFormat('fa', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: hasTime ? 'numeric' : undefined,
    minute: hasTime ? 'numeric' : undefined,
    ...options,
  }).format(timeStamp * 1000);
};
export default convertTimeStampToDate;
